function _set(name, value, days, path) {
    if (!path) {
        path = '/';
    }
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=' + path;
}

function _get(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function _delete(name, path) {
    _set(name, '', -1, path);
}

export const Cookie = {
    API_KEY: 'apiKey',
    SELLER_ID: 'sellerId',
    VALIDITY: 30,

    setApiKey(apiKey) {
        if (apiKey === null) {
            _delete(this.API_KEY);
        }
        else {
            _set(this.API_KEY, apiKey, this.VALIDITY);
        }
    },

    getApiKey() {
        return _get(this.API_KEY);
    },

    setSellerId(sellerId) {
        if (sellerId === null) {
            _delete(this.SELLER_ID);
        }
        else {
            _set(this.SELLER_ID, sellerId, this.VALIDITY);
        }
    },

    getSellerId() {
        return _get(this.SELLER_ID);
    }
};


// WEBPACK FOOTER //
// ./src/js/application/Cookie.js